import { inject, Injectable } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { ToastFacade } from '../state/toasts/toast.facade';
import { ToastType } from './models/toast.model';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly configService = inject(ConfigService);
  private readonly translateService = inject(TranslateService);
  private readonly toastFacade = inject(ToastFacade);

  showToast(label: string, type: ToastType = 'success', params: Record<string, unknown> = {}) {
    this.toastFacade.createToast({ message: this.translateService.instant(label, params), type });
  }

  showToastRaw(message: string, type: ToastType = 'success') {
    this.toastFacade.createToast({ message, type });
  }

  showToastSolution(label: string, type: ToastType = 'success', params: Record<string, unknown> = {}) {
    const { customerType: { dbValue } } = this.configService.get();
    const computedLabel = `${label}.${dbValue.toLowerCase()}`;
    let translation = this.translateService.instant(computedLabel, params);

    if (!translation || translation === computedLabel) {
      translation = this.translateService.instant(label, params);
    }

    this.toastFacade.createToast({ message: translation, type });
  }
}
